import { HttpSuccessDto } from "@common/dto/http";
import { UserMaintenanceProfile } from "@common/dto/user-maintenance/profile";
import client from "@common/utils/rest";

export const getProfiles = (): Promise<Array<UserMaintenanceProfile>> => {
  return client({
    path: 'api/userMaintenance/profiles',
    method: 'GET'
  }).then(
    (response: HttpSuccessDto<Array<UserMaintenanceProfile>>) => {
      return response.entity;
    },
  );
};